import deviceOverviewRedux from 'Modules/devices/views/overview/redux/reducer';
import vidFleetVideoRedux from 'Modules/devices/.components/vidFleetVideo/redux/reducer';
import devicesCommonRedux from 'Modules/devices/common/redux/reducer';
import bulkPairingRedux from 'Modules/devices/.components/bulkPairing/redux/reducer';
import bulkActionsRedux from 'Modules/devices/.components/bulkActions/redux/reducer';
import deviceDetailsRedux from 'Modules/devices/views/main/.components/Details/redux/reducer';
import activateCameraSimCardRedux from 'Modules/devices/.components/activateSimCard/redux/reducer';
import changeSimProviderRedux from 'Modules/devices/.components/changeSimProvider/redux/reducer';
import importDevicesRedux from 'Modules/devices/.components/importDevices/redux/reducer';
import bulkUnpairingRedux from 'Modules/devices/.components/bulkUnpairing/redux/reducer';
import assignFirmwareDeviceRedux from 'Modules/devices/.components/assignFirmware/redux/reducer';
import simInfoRedux from 'Modules/devices/.components/simInfoTab/redux/reducer';
import pulsInfoRedux from 'Modules/devices/.components/pulsInfoTab/redux/reducer';
import featureTabRedux from 'Modules/devices/.components/featureTab/redux/reducer';
import featureTabUpdateFeatureRedux from 'Modules/devices/.components/featureTab/.components/updateFeature/redux/reducer';
import troubleShootingEventsRedux from 'Modules/devices/.components/troubleShootingEventsTab/redux/reducer';
import requestDeviceLogRedux from 'Modules/devices/.components/requestDeviceLog/redux/reducer';
import formatSDCardRedux from 'Modules/devices/.components/formatSDCard/redux/reducer';
import rebootDeviceRedux from 'Modules/devices/.components/rebootDevice/redux/reducer';
import associateToGpsRedux from 'Modules/devices/views/overview/.components/associateToGps/redux/reducer';
import messagesOutboxRedux from 'Modules/devices/.components/messagesOutboxTab/redux/reducer';
import editSwapSimCardRedux from 'Modules/devices/.components/editSwapSimCard/redux/reducer';
import sendCommandRedux from 'Modules/devices/.components/sendCommand/redux/reducer';
import changePulsCustomerRedux from 'Modules/devices/.components/changePulsCustomer/redux/reducer';
import changeScriptRedux from 'Modules/devices/.components/changeScript/redux/reducer';
import changeStatusRedux from 'Modules/devices/.components/changeStatus/redux/reducer';
import moveToOtherAccountRedux from 'Modules/devices/.components/moveToOtherAccount/redux/reducer';
import markAsRmaRedux from 'Modules/devices/.components/markAsRma/redux/reducer';
import refurbishDeviceRedux from 'Modules/devices/.components/refurbishDevice/redux/reducer';
import createEditNoteRedux from 'Modules/devices/.components/notesTab/.components/createEditNote/redux/reducer';
import deleteNoteRedux from 'Modules/devices/.components/notesTab/.components/deleteNote/redux/reducer';
import lastReadingRedux from 'Modules/devices/views/main/.components/Details/.components/lastReading/redux/reducer';
import revertRmaRedux from 'Modules/devices/.components/revertRma/redux/reducer';
import changeTimezoneRedux from 'Modules/devices/.components/changeTimezone/redux/reducer';
import dailyDeviceAuditRedux from 'Modules/devices/.components/dailyDeviceAudit/redux/reducer';
import coverageDetailsRedux from 'Modules/devices/.components/coverageDetails/redux/reducer';
import createDiagnosticDeviceRedux from 'Modules/devices/.components/createDiagnosticDevice/redux/reducer';
import coverageDetailInfoRedux from 'Modules/devices/.components/coverageDetailInfo/redux/reducer';
/* import maintenanceWarningsRedux from 'Modules/devices/.components/maintenanceWarnings/redux/reducer'; */
import createClipRequestRedux from 'Modules/devices/.components/createClipRequest/redux/reducer';
import deleteClipRequestRedux from 'Modules/devices/.components/deleteClipRequest/redux/reducer';
import clipRequestTabRedux from 'Modules/devices/.components/clipRequestTab/redux/reducer';

//Slice
import castImportManualRedux from '../../.components/castImportManual/redux/slice';
import maintenanceWarningsDetailedListRedux from '../../.components/maintenanceWarnings/.components/detailedList/redux/slice';
import maintenanceWarningsResolveRedux from '../../.components/maintenanceWarnings/.components/resolveMaintenanceWarningEvent/redux/slice';
import maintenanceWarningsConfirmResolveRedux from '../../.components/maintenanceWarnings/.components/resolveMaintenanceWarningEvent/redux/slice';
import confirmResolveMaintenanceWarningEventsRedux from '../../.components/maintenanceWarnings/.components/confirmResolveMaintenanceWarningEvent/redux/slice';
import maintenanceWarningsDeleteRedux from '../../.components/maintenanceWarnings/.components/deleteMaintenanceWarningEvent/redux/slice'
import maintenanceWarningsRedux from '../../.components/maintenanceWarnings/redux/slice';
import devicesMainRedux from '../../views/main/redux/slice';
//export redux objects
export default {
	deviceOverviewRedux,
	vidFleetVideoRedux,
	devicesCommonRedux,
	bulkPairingRedux,
	bulkActionsRedux,
	deviceDetailsRedux,
	activateCameraSimCardRedux,
	changeSimProviderRedux,
	importDevicesRedux,
	bulkUnpairingRedux,
	assignFirmwareDeviceRedux,
	simInfoRedux,
	pulsInfoRedux,
	featureTabRedux,
	featureTabUpdateFeatureRedux,
	troubleShootingEventsRedux,
	requestDeviceLogRedux,
	formatSDCardRedux,
	rebootDeviceRedux,
	associateToGpsRedux,
	messagesOutboxRedux,
	editSwapSimCardRedux,
	sendCommandRedux,
	changePulsCustomerRedux,
	changeScriptRedux,
	changeStatusRedux,
	moveToOtherAccountRedux,
	markAsRmaRedux,
	refurbishDeviceRedux,
	createEditNoteRedux,
	deleteNoteRedux,
	lastReadingRedux,
	revertRmaRedux,
	changeTimezoneRedux,
	dailyDeviceAuditRedux,
	coverageDetailsRedux,
	createDiagnosticDeviceRedux,
	coverageDetailInfoRedux,
	maintenanceWarningsRedux,
	createClipRequestRedux,
	deleteClipRequestRedux,
	clipRequestTabRedux,
	maintenanceWarningsDetailedListRedux,
	maintenanceWarningsResolveRedux,
	confirmResolveMaintenanceWarningEventsRedux,
	maintenanceWarningsConfirmResolveRedux,
	maintenanceWarningsDeleteRedux,
	castImportManualRedux,
	devicesMainRedux,
};